import React from 'react';
import { Helmet } from 'react-helmet';
// import Food from '../components/Food';

const FoodPage = () => {
  return (
    <>
      <Helmet>
        <title>Foods / Dishes</title>
      </Helmet>
      {/* <Food /> */}
    </>
  );
};

export default FoodPage;
